export const translateLocationName = (name: string, language: string): string => {
    if (!name) return '';
    const cleanName = name.trim();
    
    const dictionary: Record<string, Record<string, string>> = {
        sv: {
            'croatia': 'Kroatien',
            'egypt': 'Egypten',
            'greece': 'Grekland',
            'athens': 'Aten',
            'rhodes': 'Rhodos',
            'spain': 'Spanien',
            'tenerife': 'Teneriffa',
            'turkey': 'Turkiet',
            'cyprus': 'Cypern',
            'united arab emirates': 'Förenade Arabemiraten',
            'morocco': 'Marocko',
            'lisbon': 'Lissabon',
            'italy': 'Italien',
            'rome': 'Rom',
            'venice': 'Venedig',
            'florence': 'Florens',
            'milan': 'Milano',
            'france': 'Frankrike',
            'gothenburg': 'Göteborg',
            'copenhagen': 'Köpenhamn',
            'malmo': 'Malmö',
            'sweden': 'Sverige',
            'denmark': 'Danmark',
            'norway': 'Norge',
            'abu dhabi': 'Abu Dhabi',
            'malaga': 'Málaga',
            // Swedish keys to Swedish
            'kroatien': 'Kroatien',
            'egypten': 'Egypten',
            'grekland': 'Grekland',
            'aten': 'Aten',
            'rhodos': 'Rhodos',
            'spanien': 'Spanien',
            'teneriffa': 'Teneriffa',
            'turkiet': 'Turkiet',
            'cypern': 'Cypern',
            'förenade arabemiraten': 'Förenade Arabemiraten',
            'marocko': 'Marocko',
            'lissabon': 'Lissabon',
            'italien': 'Italien',
            'rom': 'Rom',
            'venedig': 'Venedig',
            'florens': 'Florens',
            'milano': 'Milano',
            'frankrike': 'Frankrike',
            'göteborg': 'Göteborg',
            'köpenhamn': 'Köpenhamn',
            'malmö': 'Malmö',
            'sverige': 'Sverige',
            'danmark': 'Danmark',
            'norge': 'Norge',
            'málaga': 'Málaga'
        },
        da: {
            'croatia': 'Kroatien',
            'egypt': 'Egypten',
            'greece': 'Grækenland',
            'athens': 'Athen',
            'rhodes': 'Rhodos',
            'spain': 'Spanien',
            'turkey': 'Tyrkiet',
            'cyprus': 'Cypern',
            'united arab emirates': 'De Forenede Arabiske Emirater',
            'morocco': 'Marokko',
            'lisbon': 'Lissabon',
            'italy': 'Italien',
            'rome': 'Rom',
            'venice': 'Venedig',
            'florence': 'Firenze',
            'milan': 'Milano',
            'france': 'Frankrig',
            'gothenburg': 'Gøteborg',
            'copenhagen': 'København',
            'malmo': 'Malmø',
            'sweden': 'Sverige',
            'denmark': 'Danmark',
            'norway': 'Norge',
            'abu dhabi': 'Abu Dhabi',
            'malaga': 'Málaga',
            // Swedish keys to Danish
            'kroatien': 'Kroatien',
            'egypten': 'Egypten',
            'grekland': 'Grækenland',
            'aten': 'Athen',
            'rhodos': 'Rhodos',
            'spanien': 'Spanien',
            'teneriffa': 'Tenerife',
            'turkiet': 'Tyrkiet',
            'cypern': 'Cypern',
            'förenade arabemiraten': 'De Forenede Arabiske Emirater',
            'marocko': 'Marokko',
            'lissabon': 'Lissabon',
            'italien': 'Italien',
            'rom': 'Rom',
            'venedig': 'Venedig',
            'florens': 'Firenze',
            'milano': 'Milano',
            'frankrike': 'Frankrig',
            'göteborg': 'Gøteborg',
            'köpenhamn': 'København',
            'malmö': 'Malmø',
            'sverige': 'Sverige',
            'danmark': 'Danmark',
            'norge': 'Norge',
            'málaga': 'Málaga'
        }
    };

    const langDict = dictionary[language];
    if (!langDict) return cleanName;

    // Helper to translate a single word/phrase case-insensitively
    const translateWord = (word: string): string => {
        const cleanWord = word.trim().toLowerCase();
        return langDict[cleanWord] || word;
    };

    // Split on delimiters (comma, semicolon, parentheses, slash, dash) but preserve them in tokens
    const tokens = cleanName.split(/(,|;|\(|\)|\/|-)/);
    
    const translatedTokens = tokens.map(token => {
        // If the token is a delimiter, return it as is
        if (/^(,|;|\(|\)|\/|-)$/.test(token)) {
            return token;
        }
        
        // Translate the word/phrase token, preserving surrounding spacing
        const leadingSpace = token.match(/^\s*/)?.[0] || '';
        const trailingSpace = token.match(/\s*$/)?.[0] || '';
        const word = token.trim();
        if (!word) return token;
        
        const translated = translateWord(word);
        return leadingSpace + translated + trailingSpace;
    });

    return translatedTokens.join('');
};
